import { IAPIErrorResponse } from "../../Data/Interfaces/Base/IAPIErrorResponse";
import { IResponse } from "../../Data/Interfaces/Base/IResponse";
import { IPlano } from "../../Data/Interfaces/Request/Plano/IPlano";
import { createAction, Action, ActionsUnion } from "../../Utils/actionHelpers";

export enum PlanoActionKeys {
  GET_PLANO_SUCCESS = "[PLANOS]GET_PLANO_SUCCESS",
  GET_ALL_PLANOS_SUCCESS = "[PLANOS]GET_ALL_PLANOS_SUCCESS",

  SET_LOADING = "[PLANOS]SET_LOADING",
}

export const PlanoActions = {
  getPlanosSuccess: (
    data: IResponse<IPlano> | IAPIErrorResponse
  ): PlanoEncerradoSuccessAction =>
    createAction(PlanoActionKeys.GET_PLANO_SUCCESS, data),

  getAllPlanosSuccess: (data: IResponse<IPlano[]>): AllPlanosSuccessAction =>
    createAction(PlanoActionKeys.GET_ALL_PLANOS_SUCCESS, data),

  setLoading: (isLoading: boolean): StartLoadingAction =>
    createAction(PlanoActionKeys.SET_LOADING, isLoading),
};

export type PlanoActionUnion = ActionsUnion<typeof PlanoActions>;

export type PlanoEncerradoSuccessAction = Action<
  PlanoActionKeys.GET_PLANO_SUCCESS,
  IResponse<IPlano> | IAPIErrorResponse
>;

export type AllPlanosSuccessAction = Action<
  PlanoActionKeys.GET_ALL_PLANOS_SUCCESS,
  IResponse<IPlano[]>
>;

export type StartLoadingAction = Action<PlanoActionKeys.SET_LOADING, boolean>;
